import React, { createContext, useEffect, useRef, useState } from "react";
import { getMapFilters, getMapMarkers } from "../repo/MapFiltersRepo";
import { useJsApiLoader } from "@react-google-maps/api";
const MapContext = createContext();

const MapProvider = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDNoORt5BsX3kcCAS9ACeHm7ZuXJicpQ0s",
    libraries: ["places"],
  });

  const center = { lat: 24.7136, lng: 46.6753 };


  const [map, setMap] = useState(/** @type google.maps.Map */ (null));

  const loadMap = (map) => {
    setMap(map);
  };

  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distance, setDistance] = useState("");
  const [duration, setDuration] = useState("");
  const [closeDuration, setCloseDuration] = useState(true);
  const [closeFilter, setCloseFilter] = useState(true);

  /** @type React.MutableRefObject<HTMLInputElement> */
  const originRef = useRef();
  /** @type React.MutableRefObject<HTMLInputElement> */
  const destiantionRef = useRef();



  
  async function calculateRoute() {
    if (originRef.current.value === "" || destiantionRef.current.value === "") {
      return;
    }
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService();
    const results = await directionsService.route({
      origin: originRef.current.value,
      destination: destiantionRef.current.value,
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
    });
    setDirectionsResponse(results);
    setDistance(results.routes[0].legs[0].distance.text);
    setDuration(results.routes[0].legs[0].duration.text);
  }

  function clearRoute() {
    setDirectionsResponse(null);
    setDistance("");
    setDuration("");
    originRef.current.value = "";
    destiantionRef.current.value = "";
  }



  const [filters, setFilters] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isInit, setIsInit] = useState(false);

  useEffect(() => {
    if (!isInit) {
      setIsInit(true);
      fetchFilters();
      fetchMarkers();
    }
  }, [isInit]);

  async function fetchMarkers() {
    try {
      setLoading(true);
      setMarkers(await getMapMarkers());
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  }

  async function fetchFilters() {
    try {
      setLoading(true);
      setFilters(await getMapFilters());
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  }
  
  return (
    <MapContext.Provider
      value={{
        originRef,
        destiantionRef,
        center,
        directionsResponse,
        distance,
        duration,
        map,
        loadMap,
        isLoaded,
        filters,
        markers,
        loading,
        error,
        isInit,
        clearRoute,
        calculateRoute,
        closeDuration,
        setCloseDuration,
        closeFilter,
        setCloseFilter
      }}  
    >
      {children}
    </MapContext.Provider>
  );
};

export { MapContext, MapProvider };
